export enum OfferTarget {
   SERRA1 = 'Sierra 1',
   SERRA2 = 'Sierra 2',
   TRITURACION = 'Trituración'
}
